import device from './device'
import files from './files'
import staff from './staff'
import didiAlarm from './didiAlarm'
import message from './message'

export default [{
  path: '/admin/institution',
  name: 'InstitutionIndex',
  component: () => import('@/views/institution/index/index'),
  meta: {
    auth: true,
    headType: -1, // 头部类型：-1：无 0：应用 1：站点 2：企业
    routerType: 2 // 0：企业 1：应用 2：企业
  }
}, {
  path: '/admin/institution/scene/:sceneId',
  name: 'InstitutionScene',
  component: () => import('@/views/institution/scene/index'),
  meta: {
    auth: true,
    headType: 2, // 企业头部
    routerType: 2 // 企业路由
  }
}, ...device, ...files, ...staff, ...didiAlarm, ...message]



// WEBPACK FOOTER //
// ./src/router/institution/index.js